"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PRECISION = 0.00001; // numbers less than this is considered as 0
function isNumberEqual(a, b, precision) {
    if (precision === void 0) { precision = PRECISION; }
    return Math.abs((a - b)) < precision;
}
exports.default = isNumberEqual;
;
//# sourceMappingURL=is-number-equal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-number-equal.js
// module id = 1123
// module chunks = 37